module.exports = __webpack_public_path__ + "img/schoolMember.6c685f1f.svg";